import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Live tenant-scoped users list (owner/HQ admin management view).
export function subscribeUsers({ tenantId }, onChange, onError) {
  if (!tenantId) {
    onChange([]);
    return () => {};
  }
  const q = query(collection(db, 'users'), where('tenantId', '==', tenantId));
  return onSnapshot(
    q,
    (snap) => onChange(snap.docs.map((d) => ({ uid: d.id, ...d.data() }))),
    (err) => (onError ? onError(err) : console.error('users listener error', err)),
  );
}

// A manager's direct team (agents). Single-field `reportsTo` query so every
// returned doc satisfies the manager users-read rule (reportsTo == uid) — no
// composite index, no permission error from over-broad results. Filters to
// active agents client-side. Used by the manager "filter by salesman" dropdown
// and the team-named scope banner (T-U3-006 / T-U3-007 / T-U3-012).
export function subscribeTeamAgents({ managerUid }, onChange, onError) {
  if (!managerUid) {
    onChange([]);
    return () => {};
  }
  const q = query(collection(db, 'users'), where('reportsTo', '==', managerUid));
  return onSnapshot(
    q,
    (snap) => onChange(
      snap.docs
        .map((d) => ({ uid: d.id, ...d.data() }))
        .filter((u) => u.role === 'agent' && u.active !== false),
    ),
    (err) => (onError ? onError(err) : console.error('team agents listener error', err)),
  );
}
